import flagCs from "../images/flag-cs@2x.png";
import flagDe from "../images/flag-de@2x.png";
import flagEn from "../images/flag-en@2x.png";
import flagFr from "../images/flag-fr@2x.png";
import flagPl from "../images/flag-pl@2x.png";
import flagRu from "../images/flag-ru@2x.png";
import flagSk from "../images/flag-sk@2x.png";
import flagUk from "../images/flag-uk@2x.png";

// ikonky vlajek např. https://www.iconninja.com/142-mini-country-flags-icon-sets-358

const CZECH = 'cs';
const ENGLISH = 'en';
const FRENCH = 'fr';
const GERMAN = 'de';
const POLISH = 'pl';
const RUSSIAN = 'ru';
const SLOVAK = 'sk';
const UKRAINIAN = 'uk';

const languageToFlag = {
	[CZECH]: flagCs,
	[ENGLISH]: flagEn,
	[FRENCH]: flagFr,
	[GERMAN]: flagDe,
	[POLISH]: flagPl,
	[RUSSIAN]: flagRu,
	[SLOVAK]: flagSk,
	[UKRAINIAN]: flagUk,
};

const getFlag = (language) => {
	return languageToFlag[language] || null;
};

const getOptionLabels = () => ({
	[CZECH]: 'česky',
	[ENGLISH]: 'english',
	[FRENCH]: 'français',
	[GERMAN]: 'deutsch',
	[POLISH]: 'polski',
	[RUSSIAN]: 'pусский',
	[SLOVAK]: 'slovensky',
	[UKRAINIAN]: 'українська',
});

const getOptions = () => {
	const options = [];

	for (let value of Object.keys(getOptionLabels())) {
		const label = getOptionLabels()[value];
		options.push({
			value,
			label,
			image: getFlag(value),
		});
	}

	return options;
};


export default {
	CZECH,
	ENGLISH,
	FRENCH,
	GERMAN,
	POLISH,
	RUSSIAN,
	SLOVAK,
	UKRAINIAN,

	getOptions,
}


// WEBPACK FOOTER //
// ./src/enums/Language.js